"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),r=require("prop-types"),t=require("@vds-core/typography");function l(e){return e&&e.__esModule?e:{default:e}}var i=l(e);const u={bold:l(r).default.bool},a=function(e){let r,l;return r="XSmall"===e.size?"small":e.size,l="large"===e.size&&"mobile"!==e.viewport||"XLarge"===e.size||"2XLarge"===e.size?"light":"regular",i.default.createElement(t.Title,Object.assign({},e,{size:r,fontSize:null,lineHeight:null,letterSpacing:null,regularWeight:l}))};a.propTypes=u,exports.default=a;



//////////////////
// WEBPACK FOOTER
// ./~/@vds/tabs/~/@vds/typography/cjs/components/Title/Title.js
// module id = 1607
// module chunks = 0